import { render, staticRenderFns } from "./ecommerce-navbar.vue?vue&type=template&id=19ecba88"
import script from "./ecommerce-navbar.vue?vue&type=script&lang=ts"
export * from "./ecommerce-navbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports